module.exports = __webpack_public_path__ + "static/process-bg.efbab12c.png";